import React from 'react';
import Icon from '../../../components/AppIcon';

const CommunityStats = () => {
  const stats = [
    {
      icon: 'Users',
      value: '12,500+',
      label: 'Aktif Üye',
      color: 'text-primary'
    },
    {
      icon: 'Calendar',
      value: '850+',
      label: 'Düzenlenen Etkinlik',
      color: 'text-secondary'
    },
    {
      icon: 'MapPin',
      value: '120+',
      label: 'SUP Noktası',
      color: 'text-accent'
    },
    {
      icon: 'Star',
      value: '4.8/5',
      label: 'Kullanıcı Puanı',
      color: 'text-warning'
    }
  ];

  return (
    <div className="w-full bg-gradient-to-br from-primary/5 to-secondary/5 rounded-xl md:rounded-2xl lg:rounded-3xl p-6 md:p-8 lg:p-10 border border-border">
      <div className="text-center mb-6 md:mb-8 lg:mb-10">
        <h3 className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground mb-2 md:mb-3">
          Türkiye'nin En Büyük SUP Topluluğu
        </h3>
        <p className="text-sm md:text-base lg:text-lg text-muted-foreground">
          Binlerce SUP tutkunu ile tanışın ve deneyimlerinizi paylaşın
        </p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5 lg:gap-6">
        {stats?.map((stat, index) => (
          <div
            key={index}
            className="flex flex-col items-center text-center p-4 md:p-5 lg:p-6 bg-card rounded-lg md:rounded-xl border border-border transition-smooth hover:shadow-organic hover:scale-105"
          >
            <div className={`${stat?.color} mb-3 md:mb-4`}>
              <Icon name={stat?.icon} size={28} strokeWidth={2} />
            </div>
            <div className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-1 md:mb-2">
              {stat?.value}
            </div>
            <div className="text-xs md:text-sm lg:text-base text-muted-foreground font-medium">
              {stat?.label}
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 md:mt-8 lg:mt-10 pt-6 md:pt-7 lg:pt-8 border-t border-border">
        <div className="flex items-center justify-center gap-2 md:gap-3 text-success">
          <Icon name="TrendingUp" size={20} />
          <p className="text-sm md:text-base lg:text-lg font-medium">
            Son 30 günde 1,200+ yeni üye katıldı
          </p>
        </div>
      </div>
    </div>
  );
};

export default CommunityStats;